import { render, staticRenderFns } from "./areaDasboard.vue?vue&type=template&id=23786a49&"
import script from "./areaDasboard.vue?vue&type=script&lang=js&"
export * from "./areaDasboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports